/* istanbul ignore file */
import { all, call, spawn } from 'redux-saga/effects';

import { sagaMiddleware } from '@/store/abstract-middleware-args';

import analytics from '@/sagas/analytics';
import app from '@/sagas/app';
import application from '@/sagas/application';
import b2bCompanies from '@/sagas/b2b-companies';
import course from '@/sagas/course';
import error from '@/sagas/error';
import lesson from '@/sagas/lesson';
import lessonHistory from '@/sagas/lesson-history';
import login from '@/sagas/login';
import student from '@/sagas/student';
import trialLesson from '@/sagas/trial-lesson';

import teacher from '@/sagas/teacher';
import user from '@/sagas/user';
import sidebar from '@/sagas/sidebar';
import clientState from '@/sagas/client-state';
import breakpoint from '@/sagas/breakpoint';
import payment from '@/sagas/payment';
import admin from '@/sagas/admin';

import chatClass from '@/sagas/book/chat';
import exerciseClass from '@/sagas/book/exercise';
import grammarClass from '@/sagas/book/grammar';
import subscriberClass from '@/sagas/book/subscriber';
import syncLogicClass from '@/sagas/book/sync-logic';
import trainingClass from '@/sagas/book/training';
import vocabularyClass from '@/sagas/book/vocabulary';

export function* rootSaga() {
  const sagas = [
    analytics,
    admin,
    app,
    application,
    b2bCompanies,
    course,
    error,
    lesson,
    lessonHistory,
    login,
    sidebar,
    student,
    teacher,
    user,
    clientState,
    breakpoint,
    payment,
    trialLesson,
    chatClass,
    exerciseClass,
    grammarClass,
    subscriberClass,
    syncLogicClass,
    trainingClass,
    vocabularyClass,
  ];

  return yield all(sagas.map((saga) => spawn(function* () {
    while (true) {
      try {
        yield call(saga);
        break;
      } catch (e) {
        console.log(e);
      }
    }
  })));
}

export default function () {
  sagaMiddleware.run(rootSaga);
}
